module.exports = __webpack_public_path__ + "img/review-bg.f9531d4c.jpg";